<template>
  <footer class="app-footer">
    <div class="container footer-content">
      <div class="footer-left">
        <h3>FUSING - 多源融合定位导航平台</h3>
        <ul class="contact-info">
          <li>电话：</li>
          <li>传真：</li>
          <li>邮箱：E-mail：gsf@whu.edu.cn</li>
          <li>邮编：430079</li>
        </ul>
      </div>
<div class="footer-right">
  <a href="https://gnsscenter.whu.edu.cn/info/1301/1191.htm" target="_blank" class="qrcode-link">
    <img src="@/assets/images/qrcode.png" alt="微信公众号" class="qrcode">
  </a>
  <a href="https://gnsscenter.whu.edu.cn/info/1301/1191.htm" target="_blank">
    <p>扫描关注微信公众号</p>
  </a>
</div>
    </div>
    <div class="footer-bottom">
      <div class="container">
        <div class="divider"></div>
        <p>www.fusing.com | 苏ICP备12345678号</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter'
}
</script>

<style scoped>
.app-footer {
  background-color: var(--primary-color);
  color: white;
  padding: 40px 0 0;
}

.footer-content {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding-bottom: 30px;
}

.footer-left h3 {
  color: var(--secondary-color);
  margin-bottom: 20px;
  font-size: 18px;
}

.contact-info {
  list-style: none;
  padding: 0;
  margin: 0;
}

.contact-info li {
  margin-bottom: 10px;
  font-size: 14px;
  color: #ccc;
}

.qrcode {
  width: 100px;
  height: 100px;
  margin-bottom: 10px;
  border: 2px solid var(--secondary-color);
  border-radius: 8px;
}

.footer-right {
  text-align: center;
}

.footer-right p {
  font-size: 12px;
  color: #ccc;
}

.footer-bottom {
  background-color: rgba(0, 0, 0, 0.2);
  padding: 20px 0;
}

.divider {
  height: 1px;
  background-color: rgba(255, 255, 255, 0.1);
  margin-bottom: 15px;
}

.footer-bottom p {
  text-align: center;
  font-size: 12px;
  color: #999;
  margin: 0;
}

@media (max-width: 768px) {
  .footer-content {
    flex-direction: column;
    gap: 30px;
    text-align: center;
  }
  
  .contact-info {
    display: inline-block;
    text-align: left;
  }
}
</style>